<template>
	<ul v-if="menuItems.length > 0">
		<MenuItem
				v-for="item in menuItems"
				:key="item.text"
				:to="item.to"
				:text="item.text"
				:sub-items="item.items"
				:menu-style="menuStyle"
		/>
	</ul>
</template>
<script setup lang="ts">
	import type {PropType} from 'vue';
	import MenuItem from '~/components/layout/menu/MenuItem.vue';
	import type {MenuEntry} from '~/lib/types/MenuTypes';

	defineProps({
		menuItems: {
			type: Array as PropType<Array<MenuEntry>>,
			default: () => []
		},
		menuStyle: {
			type: String as PropType<'primary' | 'secondary' | 'default'>,
			default: 'default'
		}
	});
</script>

<style scoped>
	ol, ul, li {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	ul {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
</style>
